module.exports = __webpack_public_path__ + "static/media/traffic-cones.8d5673e0.svg";